// jQuery('#tabs-nav li:first-child').addClass('active');
// jQuery('.tab-content').hide();
// jQuery('.tab-content:first').show();
      
// // Click function
// jQuery('#tabs-nav li').click(function(){
//   jQuery('#tabs-nav li').removeClass('active');
//   jQuery(this).addClass('active');
//   jQuery('.tab-content').hide();
  
//   var activeTab = jQuery(this).find('a').attr('href');
//   jQuery(activeTab).fadeIn();
//   return false;
// });

// jQuery('#tabs-nav-new li:first-child').addClass('active');
// jQuery('.tabs-content-new').hide();
// jQuery('.tabs-content-new:first').show();
      
// // Click function
// jQuery('#tabs-nav-new li').click(function(){
//   jQuery('#tabs-nav-new li').removeClass('active');
//   jQuery(this).addClass('active');
//   jQuery('.tabs-content-new').hide();
  
//   var activeTab = jQuery(this).find('a').attr('href');
//   jQuery(activeTab).fadeIn();
//   return false;
// });

// $('.brand-content ul>li label').click(function() {
//   $(this).siblings(".sub-nav").toggle();
// });

// ----- #tabs-nav -----
document.querySelector('#tabs-nav li:first-child')?.classList.add('active');

document.querySelectorAll('.tab-content').forEach((tab, i) => {
  tab.style.display = i === 0 ? 'block' : 'none';
});

document.querySelectorAll('#tabs-nav li').forEach(li => {
  li.addEventListener('click', function (e) {
    e.preventDefault();

    document.querySelectorAll('#tabs-nav li').forEach(li => li.classList.remove('active'));
    this.classList.add('active');

    document.querySelectorAll('.tab-content').forEach(tab => tab.style.display = 'none');

    const href = this.querySelector('a')?.getAttribute('href');
    if (href) {
      const activeTab = document.querySelector(href);
      if (activeTab) {
        activeTab.style.display = 'block';
        activeTab.style.opacity = 0;
        let op = 0;
        const fade = setInterval(() => {
          op += 0.1;
          activeTab.style.opacity = op;
          if (op >= 1) clearInterval(fade);
        }, 30);
      }
    }
  });
});

// ----- #tabs-nav-new -----
document.querySelector('#tabs-nav-new li:first-child')?.classList.add('active');

document.querySelectorAll('.tabs-content-new').forEach((tab, i) => {
  tab.style.display = i === 0 ? 'block' : 'none';
});

document.querySelectorAll('#tabs-nav-new li').forEach(li => {
  li.addEventListener('click', function (e) {
    e.preventDefault();

    document.querySelectorAll('#tabs-nav-new li').forEach(li => li.classList.remove('active'));
    this.classList.add('active');

    document.querySelectorAll('.tabs-content-new').forEach(tab => tab.style.display = 'none');

    const href = this.querySelector('a')?.getAttribute('href');
    if (href) {
      const activeTab = document.querySelector(href);
      if (activeTab) {
        activeTab.style.display = 'block';
        activeTab.style.opacity = 0;
        let op = 0;
        const fade = setInterval(() => {
          op += 0.1;
          activeTab.style.opacity = op;
          if (op >= 1) clearInterval(fade);
        }, 30);
      }
    }
  });
});

// ----- Toggle sub-nav on label click -----
document.querySelectorAll('.brand-content ul > li label').forEach(label => {
  label.addEventListener('click', function () {
    const subNav = this.parentElement.querySelector('.sub-nav');
    if (subNav) {
      subNav.style.display = (subNav.style.display === 'block') ? 'none' : 'block';
    }
  });
});